module.exports = __webpack_public_path__ + "static/media/nosql.ea339895.png";